var React = require('react');

function Back (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Back"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-2","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","strokeOpacity":"0.6","key":2},React.createElement("g",{"id":"waiting_list","transform":"translate(-134.000000, -141.000000)","stroke":"#0A090B"},React.createElement("g",{"id":"Back","transform":"translate(134.000000, 141.000000)"},[React.createElement("line",{"x1":"31.5","y1":"6.5","x2":"0.59375","y2":"6.53125","id":"Shape","key":0}),React.createElement("polyline",{"id":"Shape","points":"6.53125 0.59375 0.59375 6.53125 6.53125 12.46875","key":1})])))]);
}

Back.defaultProps = {"width":"32px","height":"13px","viewBox":"0 0 32 13","version":"1.1"};

module.exports = Back;

Back.default = Back;
